import FeatureGuideSidebar from 'components/new-ui/composed/feature-guide-panel/FeatureGuideSidebar';
import { FeatureGuide } from 'components/new-ui/composed/feature-guide-panel/types';
import { useMultiStepFormContext } from 'components/new-ui/composed/multistep-form/MultiStepFormProvider';
import { BrokerUploadFormFields } from './types';

type Props = {
    guides: FeatureGuide[];
};

const BrokerUploadFeatureGuide = ({ guides }: Props) => {
    const { currentStepConfig } = useMultiStepFormContext<BrokerUploadFormFields>();

    return <FeatureGuideSidebar guides={guides} activeStepKey={currentStepConfig?.key as string | undefined} />;
};

export default BrokerUploadFeatureGuide;
